module.exports = __webpack_public_path__ + "static/media/icon-rule-default.2f02a75a.svg";